import React, { useState, useEffect } from 'react';
import { SafeAreaView, View, StyleSheet, FlatList } from 'react-native';
import { Text, Button, Card, Input, CheckBox, Icon } from 'react-native-elements';
import RNPickerSelect from 'react-native-picker-select';
import { Tools } from '../../utils/types/Tools';
import { ScrollView } from 'react-native-gesture-handler';
import { connect } from 'react-redux';
import { RootState } from '../../redux';
import { User } from '../../utils/types/Users';
import Firebase from '../../components/FirebaseContext';
import { SuccessToast, FailureToast } from '../../utils';
import DatePicker from 'react-datepicker';
import TouchableWrapper from '../../components/TouchableWrapper';
import { Projects } from '../../utils/types/Projects';
import firebase from 'firebase';
import { fstHelper } from '../../utils/types/others';
import { colors } from '../../utils/constants';
import { Menu, MenuTrigger, MenuOptions, MenuOption, renderers } from 'react-native-popup-menu';
import 'react-datepicker/dist/react-datepicker.css';

interface ProjectsProps {
	user: User;
}

function ProjectManager({ user }: ProjectsProps): JSX.Element {
	const firestore = Firebase.firestore();
	const [projectTitle, setProjectTitle] = useState('');
	const [projectSubTitle, setProjectSubTitle] = useState('');
	const [selectedTools, setSelectedTools] = useState<Array<string>>([]);
	const [manager, setManager] = useState<string>('');
	const [loading, setLoading] = useState(false);
	const [startDate, setStartDate] = useState<Date | null>(new Date());
	const [stopDate, setStopDate] = useState<Date | null>(new Date());

	const [tools, setTools] = useState<Array<Tools>>([]);
	const [managers, setManagers] = useState<Array<User>>([]);
	const [savedProjects, setSavedProjects] = useState<Array<{ docId: string; project: Projects }>>([]);
	useEffect(() => {
		//load managers and tools
		firestore
			.collection('users')
			.where('role', 'in', ['Admin', 'QA Manager'])
			.get()
			.then((res) => {
				if (!res.empty) {
					const m = res.docs.map((m) => m.data() as User);
					setManagers(m);
				}
			});

		firestore
			.collection('tools')
			.orderBy('createdAt', 'desc')
			.get()
			.then((res) => {
				if (!res.empty) {
					const t = res.docs.map((t) => t.data() as Tools);
					setTools(t);
				}
			});
	}, [firestore]);

	const [editId, setEditId] = useState<string>();
	useEffect(() => {
		//load all existing projects order by date created desc

		if (editId == undefined || editId == 'refresh') {
			firestore
				.collection('projects')
				.orderBy('createdAt', 'desc')
				.get()
				.then((res) => {
					if (!res.empty) {
						const p = res.docs.map((p) => {
							return { docId: p.id, project: p.data() as Projects };
						});
						setSavedProjects(p);
					}
				});
		}
	}, [firestore, editId]);

	const toolCheckBoxes = tools.map((t) => (
		<CheckBox
			key={t.id}
			title={t.name}
			checked={selectedTools.indexOf(t.id) >= 0}
			onPress={() => {
				const ind = selectedTools.indexOf(t.id);
				if (ind < 0) {
					const newSelections = [...selectedTools, ...[t.id]];
					setSelectedTools(newSelections);
				} else {
					selectedTools.splice(ind, 1);
					const newSelections: Array<string> = [];
					selectedTools.forEach((s, i) => {
						newSelections[i] = s;
					});
					setSelectedTools(newSelections);
				}
			}}
		/>
	));

	const resetProjectForm = () => {
		setProjectTitle('');
		setProjectSubTitle('');
		setSelectedTools([]);
		setManager('');
	};

	type CustomDatePickerType = {
		value?: string;
		onClick?: () => void;
	};
	const CustomDatePicker = ({ value, onClick }: CustomDatePickerType) => (
		<TouchableWrapper onPress={onClick}>
			<Input placeholder="Choose start date" value={value} editable={false} />
		</TouchableWrapper>
	);

	return (
		<SafeAreaView style={{ flex: 1, flexDirection: 'row' }}>
			<View style={{ flex: 1 }}>
				<Text style={{ fontWeight: '700', marginBottom: 20, textAlign: 'center', marginTop: 20 }} h3>
					Projects
				</Text>
				<FlatList
					data={savedProjects}
					renderItem={({ item }) => {
						const { docId, project } = item;
						return (
							<Card>
								<Text h4>
									{project.name} | {project.id}
								</Text>
								<Text>{project.description}</Text>
								<Text>
									Manager: {managers.find((m) => m.uid == project.managedBy)?.firstName}{' '}
									{managers.find((m) => m.uid == project.managedBy)?.lastName}
								</Text>
								<Text>
									Period: {new Date((project.startTime as fstHelper).toDate()).toDateString()} &nbsp; - &nbsp;{' '}
									{new Date((project.stopTime as fstHelper).toDate()).toDateString()}
								</Text>
								{new Date((project.stopTime as fstHelper).toDate()) > new Date() ? (
									<View style={{ flexDirection: 'row', position: 'absolute', right: 0 }}>
										<Icon
											reverse
											name="edit-3"
											type="feather"
											size={16}
											color={colors.green}
											onPress={() => {
												setProjectTitle(project.name);
												setProjectSubTitle(project.description);
												setManager(project.managedBy);
												setStartDate(new Date((project.startTime as fstHelper).toDate()));
												setStopDate(new Date((project.stopTime as fstHelper).toDate()));
												setSelectedTools(project.tools);
												setEditId(docId);
											}}
										/>
										<Menu renderer={renderers.Popover} rendererProps={{ preferredPlacement: 'bottom' }}>
											<MenuTrigger>
												<Icon reverse name="trash-2" type="feather" size={16} color={colors.red} />
											</MenuTrigger>
											<MenuOptions customStyles={{ optionsWrapper: { padding: 10 } }}>
												<Text style={{ color: colors.darkRed, fontWeight: '700' }}>This action is irreversible!</Text>
												<View style={{ flexDirection: 'row', justifyContent: 'space-around', marginVertical: 16 }}>
													<MenuOption
														text="Cancel"
														customStyles={{
															optionWrapper: { backgroundColor: colors.blue, borderRadius: 4, paddingHorizontal: 6 },
															optionText: { color: '#fff' },
														}}
													/>
													<MenuOption
														text="Yes delete"
														customStyles={{
															optionWrapper: { backgroundColor: colors.red, borderRadius: 4, paddingHorizontal: 6 },
															optionText: { color: '#fff' },
														}}
														onSelect={async () => {
															await firestore.collection('projects').doc(docId).delete();
															setEditId('refresh');
															SuccessToast(`Project ${project.id} has been deleted!`);
														}}
													/>
												</View>
											</MenuOptions>
										</Menu>
									</View>
								) : (
									<></>
								)}
							</Card>
						);
					}}
					ListFooterComponent={<View style={{ height: 60 }}></View>}
					keyExtractor={(item) => item.project.id}
				/>
			</View>
			<ScrollView style={{ flex: 0.4, backgroundColor: '#45a6dd' }}>
				<Card containerStyle={{ marginBottom: 20 }} title={editId != undefined ? 'Edit Project' : 'Add Project'}>
					<Input
						placeholder="Enter project title"
						value={projectTitle}
						onChangeText={(text) => {
							setProjectTitle(text);
						}}
					/>
					<Input
						placeholder="Enter project description"
						value={projectSubTitle}
						onChangeText={(text) => {
							setProjectSubTitle(text);
						}}
					/>
					<RNPickerSelect
						placeholder={{ label: 'Select Project Manager', value: '' }}
						value={manager}
						onValueChange={(itemValue) => {
							setManager(itemValue.toString());
						}}
						items={managers.map((option) => ({ label: option.firstName + ' ' + option.lastName, value: option.uid }))}
						style={PickerStyle}
					/>
					<View style={{ flexDirection: 'row', paddingHorizontal: 10, zIndex: 9 }}>
						<Text style={{ alignSelf: 'center' }}>Start Date: </Text>
						<DatePicker
							selected={startDate}
							onChange={(date) => {
								setStartDate(date);
								if (date && stopDate) {
									if (date > stopDate) setStopDate(date);
								}
							}}
							customInput={<CustomDatePicker />}
							minDate={new Date()}
							dateFormat="dd/MM/yyyy"
						/>
					</View>
					<View style={{ flexDirection: 'row', paddingHorizontal: 10, zIndex: 8 }}>
						<Text style={{ alignSelf: 'center' }}>Stop Date: </Text>
						<DatePicker
							selected={stopDate}
							onChange={(date) => setStopDate(date)}
							customInput={<CustomDatePicker />}
							minDate={startDate}
							dateFormat="dd/MM/yyyy"
						/>
					</View>
					<View>
						<Text style={{ fontSize: 16, fontWeight: '700', marginBottom: 12, marginTop: 20, paddingHorizontal: 10 }}>
							Add tool to project
						</Text>
						{toolCheckBoxes}
					</View>
					<Button
						title={editId == undefined ? 'Save Project' : 'Save Changes'}
						buttonStyle={{ backgroundColor: '#275036', paddingVertical: 6 }}
						containerStyle={{ marginTop: 20 }}
						onPress={async () => {
							if (projectTitle.length < 1) {
								FailureToast('Project must have a title');
								return;
							}
							if (manager.length < 1) {
								FailureToast('Project must have a manager');
								return;
							}
							if (selectedTools.length < 1) {
								FailureToast('A tool must be added to the project');
								return;
							}
							setLoading(true);
							const project: Projects = {
								name: projectTitle,
								description: projectSubTitle,
								id: editId ? savedProjects.find((p) => p.docId == editId)?.project.id || '' : `LASHMA-P${Date.now()}`,
								tools: selectedTools,
								createdAt: editId
									? (savedProjects.find((p) => p.docId == editId)?.project.createdAt as fstHelper).toDate()
									: firebase.firestore.FieldValue.serverTimestamp(),
								createdBy: editId ? savedProjects.find((p) => p.docId == editId)?.project.createdBy || '' : user.uid,
								startTime: startDate,
								stopTime: stopDate,
								// status: 'Active',
								managedBy: manager,
							};

							if (editId == undefined) {
								try {
									await firestore.collection('projects').add(project);
									SuccessToast('Project saved!');
									setLoading(false);
									setEditId('refresh');
								} catch (error) {
									FailureToast('Failed to save project');
									setLoading(false);
								}
							} else {
								try {
									const doc = firestore.collection('projects').doc(editId);
									doc.set(project);
									SuccessToast('Project updated!');
									setLoading(false);
									setEditId(undefined);
								} catch (error) {
									FailureToast('Failed to update project');
									setLoading(false);
								}
							}
							resetProjectForm();
						}}
						loading={loading}
					/>
				</Card>
			</ScrollView>
		</SafeAreaView>
	);
}

const PickerStyle = StyleSheet.create({
	inputIOS: {
		paddingVertical: 12,
		paddingHorizontal: 10,
		borderWidth: 0,
		borderColor: 'gray',
		borderRadius: 4,
		color: 'black',
		paddingRight: 30, // to ensure the text is never behind the icon
	},
	inputAndroid: {
		paddingHorizontal: 10,
		paddingVertical: 8,
		borderWidth: 0,
		borderColor: '#c5c5c5',
		borderBottomWidth: 1,
		borderRadius: 0,
		color: 'black',
		paddingRight: 30, // to ensure the text is never behind the icon
	},
});

const mapStateToProps = (state: RootState) => {
	const { user } = state;
	return {
		user,
	};
};

export default connect(mapStateToProps)(ProjectManager);
